export default "__VITE_ASSET__1df27f89__"